<template>
  <div class="timeline">
    <my-loader v-if="entry.loading && !entry.items.length && !entry.error" />

    <div v-else-if="entry.error" class="state error">
      Не удалось загрузить таймлайн по рейсу #{{ cargoTripId }}.
    </div>

    <div v-else-if="!entry.items.length" class="state">
      Записей по рейсу #{{ cargoTripId }} нет.
    </div>

    <div v-else class="history-list">
      <div
        v-for="item in entry.items"
        :key="item.id"
        class="history-card"
        :class="{ highlighted: item.id === highlightId }"
      >
        <div class="card-head">
          <span class="badge" :class="`badge-${item.status || 'info'}`">{{ item.status || EMPTY_VALUE }}</span>
          <span class="card-kind">{{ item.kind || EMPTY_VALUE }}</span>
          <span class="card-flow muted">{{ item.flow }} · {{ item.direction }}</span>
          <span class="card-date">{{ formatDate(item.created_dt) }}</span>
          <span v-if="item.attempt_no" class="muted">#{{ item.attempt_no }}</span>
        </div>
        <div class="card-body">
          <div class="grid">
            <div class="row"><span class="lbl">Источник</span><span class="val">{{ item.source_service || EMPTY_VALUE }}</span></div>
            <div class="row"><span class="lbl">Актор</span><span class="val">{{ item.actor || EMPTY_VALUE }}</span></div>
            <div class="row" v-if="item.driver_name"><span class="lbl">Водитель</span><span class="val">{{ item.driver_name }}</span></div>
            <div class="row" v-if="item.car_number"><span class="lbl">Машина</span><span class="val">{{ item.car_number }}</span></div>
            <div class="row" v-if="item.trailer_number"><span class="lbl">Прицеп</span><span class="val">{{ item.trailer_number }}</span></div>
            <div class="row" v-if="item.driver_tms_id"><span class="lbl">TMS водитель</span><span class="val">{{ item.driver_tms_id }}</span></div>
            <div class="row" v-if="item.car_tms_id"><span class="lbl">TMS машина</span><span class="val">{{ item.car_tms_id }}</span></div>
            <div class="row" v-if="item.trailer_tms_id"><span class="lbl">TMS прицеп</span><span class="val">{{ item.trailer_tms_id }}</span></div>
          </div>
          <div v-if="item.error_kind" class="err">
            <span class="err-kind">{{ item.error_kind }}</span>
            <span v-if="item.error_detail" class="err-detail">{{ item.error_detail }}</span>
          </div>
          <div v-if="item.tms_message" class="tms-msg" :title="item.tms_message">
            TMS: {{ item.tms_message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { formatDate, EMPTY_VALUE } from '@/pages/pureBidding/helpers';

export default {
  name: 'TmsActionTimeline',
  props: {
    cargoTripId: { type: [Number, String], required: true },
    highlightId: { type: [Number, String], default: null },
  },
  setup(props) {
    const store = useStore();
    const entry = computed(() => {
      const e = store.state.tmsActionLog.timelines[props.cargoTripId];
      return e || { items: [], loading: false, error: false };
    });
    return { EMPTY_VALUE, entry, formatDate };
  },
};
</script>

<style scoped>
.timeline { padding: 8px 12px; }

.state { padding: 16px; color: #667085; font-size: 13px; }
.state.error { color: #dc3545; }

.history-list { display: flex; flex-direction: column; gap: 8px; }

.history-card {
  border: 1px solid #e6eaf0;
  border-left: 3px solid #d7dce2;
  border-radius: 4px;
  background: #fff;
  padding: 8px 10px;
}
.history-card.highlighted {
  border-left-color: #007bff;
  background: #f3f8ff;
}

.card-head {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
  font-size: 12px;
}
.card-kind { font-weight: 700; color: #333; }
.card-date { color: #667085; margin-left: auto; }
.muted { color: #98a2b3; font-size: 11px; }
.card-flow { font-size: 11px; }

.badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}
.badge-success { background: #e6f4ea; color: #1e7e34; }
.badge-error   { background: #fdeaea; color: #c0392b; }
.badge-pending { background: #fff5e0; color: #b7791f; }
.badge-info    { background: #e8eefc; color: #2563eb; }

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 4px 16px;
  font-size: 12px;
}
.row { display: flex; gap: 6px; }
.lbl { color: #98a2b3; min-width: 92px; }
.val { color: #333; word-break: break-word; }

.err { margin-top: 6px; font-size: 12px; }
.err-kind { color: #c0392b; font-weight: 700; margin-right: 6px; }
.err-detail { color: #842029; }

.tms-msg {
  margin-top: 4px;
  font-size: 11px;
  color: #4b5563;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
